import { lazy } from 'react'
import Home from 'pages/Home'
import { ROUTE_PATHS } from 'constants/index'
const Profile = lazy(() => import('pages/Profile'))
const VerifyEmail = lazy(() => import('pages/VerifyEmail/index'))
const ForgetPassword = lazy(() => import('pages/ForgetPassword'))
const SiteInfo = lazy(() => import('pages/SiteInfo'))
const Promotions = lazy(() => import('pages/Promotion'))
const Rewards = lazy(() => import('pages/Rewards'))
const PromotionDetails = lazy(() => import('pages/Promotion/components/PromotionDetails/index'))
const PreLoginRewards = lazy(() => import('pages/PreLoginPages/Rewards/index'))
const PreLoginAffiliates = lazy(() => import('pages/PreLoginPages/Affiliates/index'))
const PredictionMarket = lazy(() => import('games/PredictionMarket/index'))

const routesList = [
  {
    path: ROUTE_PATHS.HOME,
    component: Home,
    isPrivate: false,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.LOGIN,
    showHeader: true,
    showFooter: true,
    component: Home
  },
  {
    path: ROUTE_PATHS.SIGNUP,
    showHeader: true,
    showFooter: true,
    component: Home
  },
  {
    path: ROUTE_PATHS.VERIFY_EMAIL,
    component: VerifyEmail,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.RESET_PASSWORD,
    component: ForgetPassword,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.SITE_INFO,
    component: SiteInfo,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.PROMOTIONS,
    component: Promotions,
    isPrivate: false,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.PROMOTION_DETAILS,
    component: PromotionDetails,
    isPrivate: false,
    showHeader: true,
    showFooter: true
  },
  {
    path: [
      ROUTE_PATHS.PROFILE,
      ROUTE_PATHS.BALANCE,
      ROUTE_PATHS.DEPOSIT,
      ROUTE_PATHS.WITHDRAWALS,
      // ROUTE_PATHS.REFERRALS,
      ROUTE_PATHS.SETTINGS,
      ROUTE_PATHS.TRANSACTIONS,
      ROUTE_PATHS.ACCOUNT_VERIFICATION,
      // ROUTE_PATHS.LIMITS
    ],
    component: Profile,
    isPrivate: true,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.REWARDS,
    component: Rewards,
    isPrivate: true,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.PRE_LOGIN_REWARDS,
    component: PreLoginRewards,
    isPrivate: false,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.PRE_LOGIN_AFFILIATES,
    component: PreLoginAffiliates,
    isPrivate: false,
    showHeader: true,
    showFooter: true
  },
  {
    path: ROUTE_PATHS.predictionMarket,
    component: PredictionMarket,
    isPrivate: false,
    showHeader: true,
    showFooter: false
  },
  {
    path: `${ROUTE_PATHS.predictionMarket}/:page(markets|market-detail|portfolio|terms-and-conditions|privacy-policy|aml-kyc-policy)`,
    component: PredictionMarket,
    isPrivate: false,
    showHeader: true,
    showFooter: false
  }
]

export default routesList
